import { Button, Divider, Form, Input, InputNumber, message, Modal, Select, Typography, Upload } from 'antd';
import React, { Component } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { countries } from '../../constants';

const { TextArea } = Input
const { Text } = Typography
const { Option } = Select;

class EditBOModal extends Component {
    render() {
        return (
            <div>
                <Modal
                    open={this.props.showEditBOModal}
                    title="Edit Beneficial Owner"
                    // onOk={handleOk}
                    onCancel={this.props.triggerShowEditBOModal}
                    footer={null}
                    destroyOnClose={true}
                    width={800}
                >
                    <Form
                        layout='horizontal'
                        name="editBOForm"
                        labelWrap={true}
                        labelAlign={'left'}
                        labelCol={{ span: 8 }}
                        // wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={this.props.editNewBO}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{ width: '100%', paddingLeft: 9 }}
                        colon={false}
                    >
                        <Form.Item
                            name='newBOSurname'
                            label={
                                <Text strong>
                                    Full Name
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your Surname!' }]}
                            initialValue={this.props.tempBOToEdit.boSurname}
                        >
                            <Input
                                autoFocus
                                placeholder="Enter your Surname"
                            />
                        </Form.Item>
                        <Form.Item
                            name='newBOFirstName'
                            label={
                                <Text strong>
                                    Full Name
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your First Name!' }]}
                            initialValue={this.props.tempBOToEdit.boFirstName}
                        >
                            <Input
                                autoFocus
                                placeholder="Enter your First Name"
                            />
                        </Form.Item>
                        <Form.Item
                            name='newBONIC'
                            label={
                                <Text strong>
                                    NIC/Passport No.
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your NIC No.!' }]}
                            initialValue={this.props.tempBOToEdit.boNIC}
                        >
                            <Input
                                placeholder="Enter NIC/Passport No."
                            />
                        </Form.Item>
                        <Form.Item
                            name='newBONICProof'
                            label={
                                <Text strong>
                                    Upload NIC
                                    <br />
                                    <span style={{ fontSize: 13, margin: 0, padding: 0 }}>
                                        (Max 3 documents)
                                    </span>
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please upload a picture of your NIC!' }]}
                            initialValue={this.props.tempBOToEdit.boNICProof === undefined ? null : this.props.tempBOToEdit.boNICProof}

                        >
                            <Upload
                                name='file'
                                action={process.env.REACT_APP_API + '/api/upload/attachment/'}
                                accept=".png, .jpg, .jpeg, .pdf"
                                maxCount={3}
                                defaultFileList={this.props.tempBOToEdit.boNICProof === undefined ? null : this.props.tempBOToEdit.boNICProof}
                                onChange={(info) => {
                                    if (info.file.status !== 'uploading') {
                                        console.log(info.file, info.fileList);
                                    }

                                    if (info.file.status === 'done') {
                                        message.success(`${info.file.name} file uploaded successfully`);
                                    } else if (info.file.status === 'error') {
                                        message.error(`${info.file.name} file upload failed.`);
                                    }
                                }}
                            >
                                <Button icon={<AiOutlineCloudUpload />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            name='newBONationality'
                            label={
                                <Text strong>
                                    Nationality
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please choose your nationality!' }]}
                            initialValue={this.props.tempBOToEdit.boNationality}
                        >
                            <Select
                                placeholder="Select nationality"
                                // onChange={this.onGenderChange}
                                allowClear
                                showSearch
                            >
                                {countries.map((country, index) => {
                                    return (
                                        <Option key={index} value={country.name}>{country.name}</Option>
                                    )
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name='newBOAddress'
                            label={
                                <Text strong>
                                    Permanent Address
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your current address!' }]}
                            initialValue={this.props.tempBOToEdit.boAddress}
                        >
                            <TextArea
                                placeholder="Enter Address"
                            />
                        </Form.Item>
                        <Form.Item
                            name='newBOInterestPercent'
                            label={
                                <Text strong>
                                    CONTROLLING OWNERSHIP INTEREST (%)
                                </Text>
                            }
                            // rules={[{ required: true, message: 'Please enter your address!' }]}
                            initialValue={this.props.tempBOToEdit.boInterestPercent}
                        >
                            <InputNumber
                                min={0}
                                disabled={this.props.isDisablePercentageInterest}
                                max={100}
                                step={0.01}
                                formatter={(value) => `${value}%`}
                                parser={(value) => value.replace('%', '')}
                            />
                        </Form.Item>
                        <Form.Item
                            name='newBOAddressProof'
                            label={
                                <Text strong>
                                    Upload Proof of Address
                                    <br />
                                    <span style={{ fontSize: 13 }}>
                                        (Max 3 documents)
                                    </span>
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please upload a proof of address!' }]}
                            initialValue={this.props.tempBOToEdit.boAddressProof === undefined ? null : this.props.tempBOToEdit.boAddressProof}
                        >
                            <Upload
                                name='file'
                                action={process.env.REACT_APP_API + '/api/upload/attachment/'}
                                accept=".png, .jpg, .jpeg, .pdf"
                                maxCount={3}
                                defaultFileList={this.props.tempBOToEdit.boAddressProof === undefined ? null : this.props.tempBOToEdit.boAddressProof}
                                onChange={(info) => {
                                    console.log(info)
                                    if (info.file.status !== 'uploading') {
                                        console.log(info.file, info.fileList);
                                    }

                                    if (info.file.status === 'done') {
                                        message.success(`${info.file.name} file uploaded successfully`);
                                    } else if (info.file.status === 'error') {
                                        message.error(`${info.file.name} file upload failed.`);
                                    }
                                }}
                            >
                                <Button icon={<AiOutlineCloudUpload />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Divider />
                        <div style={{ textAlign: 'right' }}>
                            <Button
                                key="back"
                                onClick={this.props.triggerShowEditBOModal}
                                style={{ marginRight: 10 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                htmlType="submit"
                                loading={this.props.isEdittingNewBoLoader}
                            >
                                Save changes
                            </Button>
                        </div>

                    </Form>
                </Modal>

            </div >
        );
    }
}

export default EditBOModal;